import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { Button } from '../../components/ui/Button';
import { GraduationCap, Lock } from 'lucide-react';
export function AdminLoginPage() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Mock login
    setTimeout(() => {
      setIsLoading(false);
      navigate('/admin/dashboard');
    }, 1500);
  };
  return <div className="min-h-screen bg-[#faf8f5] flex items-center justify-center p-4" data-id="element-365">
      <Card className="w-full max-w-md p-8" data-id="element-366">
        <div className="text-center mb-8" data-id="element-367">
          <div className="inline-flex items-center justify-center p-3 bg-[#1e3a5f] rounded-xl mb-4" data-id="element-368">
            <GraduationCap className="h-8 w-8 text-white" data-id="element-369" />
          </div>
          <h1 className="text-2xl font-bold text-[#1e3a5f]" data-id="element-370">Admin Portal</h1>
          <p className="text-gray-500 text-sm mt-2" data-id="element-371">
            Sign in to manage applications
          </p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6" data-id="element-372">
          <Input label="Email Address" type="email" placeholder="admin@studyboard.com" required data-id="element-373" />
          <Input label="Password" type="password" placeholder="••••••••" required data-id="element-374" />

          <Button fullWidth size="lg" isLoading={isLoading} className="mt-4" data-id="element-375">
            <Lock className="h-4 w-4 mr-2" data-id="element-376" />
            Sign In
          </Button>
        </form>

        <div className="mt-6 text-center text-xs text-gray-400" data-id="element-377">
          Protected area. Authorized personnel only.
        </div>
      </Card>
    </div>;
}